module.exports = __webpack_public_path__ + "img/national-emblem.d0289dc0.png";